































import { Component, Vue } from 'vue-property-decorator';

import Loading from '../components/Loading.vue';
import HttpServiceLayout from '../http/http-service-layout';

@Component({
  components: {
    Loading,
  },
})
export default class Layout extends Vue {
  private layout: any = null;

  private isLoading = false;

  private created() {
    this.initialize();
  }

  private async initialize() {
    this.layout = await this.getLayout();
  }

  private async getLayout() {
    let layout: any = null;

    this.isLoading = true;

    const response = await HttpServiceLayout.readOne(parseInt(this.$route.params.id, 10));

    this.isLoading = false;

    if (response) {
      layout = response.data;
    }

    return layout;
  }
}
